<template>
    <div>

        <div>

            <div class="form-row mb-3">
                <div class="col col-12 col-md-3">
                    <az-input 
                        placeholder="Selecione o Plano..."
                        icon="fa-regular fa-rectangle-list fa-fw" 
                        type="select"
                        service="contabil_planos.index"
                        optionsData="id_contabil_plano"
                        optionsMode="aql"
                        v-model="id_contabil_plano" 
                        @input="load()" />
                </div>

                <div class="col col-12 col-md-3">
                    <i class="" aria-hidden="true"></i>
                    <az-input 
                        placeholder="Selecione o Tipo..."
                        icon="fa fa-filter fa-fw" 
                        type="select"
                        :optionsList="[
                            { id: 'contas', search: 'Caixa/Banco' }, 
                            { id: 'categorias', search: 'Categorias' }, 
                            { id: 'operadoras', search: 'Clientes' },
                            { id: 'fornecedores', search: 'Fornecedores' },
                        ]"
                        optionsData="id"
                        v-model="tipo" 
                        @input="load()" />
                </div>

                <div class="col col-12 col-md-3">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="lista && lista.length">
                                <span class="input-group-text" id="basic-addon2" title="Vinculados" v-if="viewMode == 'T'">
                                    {{ total_vinculados }}/{{ lista.length }}
                                </span>
                                <span class="input-group-text" id="basic-addon2" title="Quantidade" v-else>
                                    {{ lista.length }}
                                </span>
                            </div>
                        </template>
                    </az-input>
                </div>

                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'N' ? 'btn-secondary' : 'btn-outline-secondary'"  @click="viewMode = 'N'">
                            Não Vinculados
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'V' ? 'btn-secondary' : 'btn-outline-secondary'"  @click="viewMode = 'V'">
                            Vinculados
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="id_contabil_plano 
                    ? ( tipo ? 'Nenhuma item identificado.' : 'Selecione o tipo' ) 
                    : 'Selecione o Plano Contábil.'" 
                icon="fas fa-search" />
		</div>

        <div v-if="lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span class="h5 mb-0 mr-3">
                        {{ dado.search }}

                        <span v-if="dado['id_' + model_by_tipo(tipo)]" class="badge badge-secondary ml-3">
                            #{{ dado['id_' + model_by_tipo(tipo)] }}
                        </span>

                        <!--
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        -->
                    </span>
                    <span>
                        <button type="button" class="btn btn-outline-secondary btn-sm" v-if="!dado.vinculo_conta" @click="vincular(dado)">
                            <i class="fa-solid fa-link-slash fa-fw"></i>
                        </button>
                        <template v-else>
                            <span class="small text-muted mr-2" v-if="dado.vinculo_conta.contabil_conta">
                                {{ dado.vinculo_conta.contabil_conta.search }}
                            </span>
                            <button type="button" class="btn btn-outline-primary btn-sm" @click="vincular(dado)">
                                <i class="fa-solid fa-link fa-fw"></i>
                            </button>
                        </template>
                    </span>
                </li>
            </div>

        </div>

        <!-- Modal Vinculo Conta -->
        <div class="modal fade" id="vinculoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Vínculo Conta Contábil
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            {{ item.search }}
                            <span v-if="item['id_' + model_by_tipo(tipo)]" class="badge badge-info">
                                #{{ item['id_' + model_by_tipo(tipo)] }}
                            </span>
                        </div>

                        <az-input
                            sizing="sm"
                            label="Conta"
                            required
                            :validate="validate"
                            type="autocomplete"
                            optionsMode="aql"
                            service="contabil_contas.index"
                            :optionsParm="{ ativos: true, id_contabil_plano: this.id_contabil_plano }"
                            v-model="item.vinculo_conta.contabil_conta">
                        </az-input>

                        <div class="mt-3" v-if="item.vinculo_conta && item.vinculo_conta.contabil_conta && item.vinculo_conta.js_info && model_by_tipo(tipo) == 'categoria'">
                            <az-input
                                sizing="sm"
                                label="Exportar Fornecedor/Cliente"
                                :validate="validate"
                                type="checkbox-group"
                                v-model="item.vinculo_conta.js_info.exp_fornecedor">
                            </az-input>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button :item="item.vinculo_conta" v-if="false" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <br><br><br>

        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="id_contabil_plano && ( tipo == 'categorias' )">
            <div class="d-flex">
                <div class="spinner-border ml-2" role="status" v-if="$store.state.loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div>
                <button type="button" class="btn btn-sm btn-outline-primary ml-2" @click="buscar_vinculos()">
                    <i class="fa-solid fa-link mr-2"></i>
                    Vincular (Cód. Externo)
                </button>
            </div>
        </nav>

        <!-- Vinculos -->
        <div class="modal fade" id="vinculosCodigoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Vincular</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state 
                            msg="Nenhum possível vínculo encontrado." 
                            icon="fa-solid fa-link" 
                            v-if="!lista_vinculos || !lista_vinculos.lista || !lista_vinculos.lista.length "/>

                        <div v-else>
                            <table class="table table-sm table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">Id</th>
                                        <th scope="col">Conta</th>
                                        <th scope="col">Categoria</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(conta_vinc, id) in lista_vinculos.lista" :key="id">
                                        <td>
                                            #{{ conta_vinc.id_contabil_conta }}
                                        </td>
                                        <td>
                                            {{ conta_vinc.search }}
                                        </td>
                                        <td>
                                            <template v-if="conta_vinc.categoria">
                                                {{ conta_vinc.categoria.search }}
                                                <span class="badge badge-secondary ml-2">
                                                    #{{ conta_vinc.categoria.id_categoria }}
                                                </span>
                                            </template>
                                        </td>                                       
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="salvar_vincular()">Vincular</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "T",
            title: "", 
            short_title: "", 
            service: "",
            id_contabil_plano: "", 
            options_classes: [], 
            tipo: "", 
        }
    },

    props: ['cadastro'],

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
    },

    computed: { 
        total_vinculados: function () { 
            return this.lista ? this.lista.filter (item => item.vinculo_conta).length : 0;
        },

        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' 
                        || ( this.viewMode == 'V' && item.vinculo_conta )
                        || ( this.viewMode == 'N' && !item.vinculo_conta ) ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

    },

    methods: { 
        model_by_tipo (tipo) { 
            switch (tipo) {
                case 'contas': return 'conta';
                case 'categorias': return 'categoria';
                case 'fornecedores': return 'fornecedor';
                case 'operadoras': return 'operadora';
            }
        },

        vincular (item) { 
            this.item = null; 
            this.validate = false;

            this.$nextTick(() => { 
                let vinculo = _.cloneDeep(item);

                if ( !vinculo.vinculo_conta ) { 
                    vinculo.vinculo_conta = { 
                        id_contabil_conta: null, 
                        model_type: 'App\\azure\\' + this.model_by_tipo(this.tipo),
                        model_id: item['id_' + this.model_by_tipo(this.tipo)],
                        contabil_conta: "",
                        js_info: { 
                            exp_fornecedor: true, 
                        }
                    };
                } else if ( !vinculo.vinculo_conta.js_info ) { 

                    vinculo.vinculo_conta.js_info = { 
                        exp_fornecedor: true, 
                    };

                }
                
                this.item = vinculo;

                $('#vinculoModal').modal('show');
            });
        },

        filtrar(texto) { 
            if ( !texto ) { 
                this.search = "";
                return;
            }

            const pesq = '"' + texto + '"';

            this.search = ( pesq == this.search ) ? "" : pesq; 
        },

        load () { 
            if ( !this.id_contabil_plano || !this.tipo ) { 
                this.dados = null;
                return;
            }

            this.$util.load(this, { 
                service: this.tipo,
                func: 'index',
                parms: { 
                    cadastro: true, 
                    ativas: true, 
                    id_contabil_plano: this.id_contabil_plano, 
                },
                loadTo: res => { 
                    this.dados = _.orderBy(res, 'search');
                }
            });
        },

        atualizar () { 
            if ( this.item.vinculo_conta && this.item.vinculo_conta.contabil_conta ) { 
                this.item.vinculo_conta.id_contabil_conta = this.item.vinculo_conta.contabil_conta.id_contabil_conta;
            }

            this.$util.atualizar(this, { 
                service: 'contabil_conta_vinculos',
                dados: this.item.vinculo_conta,
                reload: true, 
                modal: 'vinculoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },

        buscar_vinculos() { 

            this.lista_vinculos = null;

            $('#vinculosCodigoModal').modal('show');

            this.$util.load(this, { 
                service: 'contabil', 
                func: 'buscar_vinculos',
                parms: { 
                    id_contabil_plano: this.id_contabil_plano, 
                },
                loadTo: res => { 
                    this.lista_vinculos = res;
                }
            });

        },

        salvar_vincular() { 

            this.$util.atualizar(this, { 
                service: 'contabil',
                func: 'salvar_vinculos', 
                dados: { 
                    id_contabil_plano: this.id_contabil_plano, 
                    lista: this.lista_vinculos.lista,
                },
                reload: true, 
                modal: 'vinculosCodigoModal',
                toast: true, 
            });

        }

    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Contabilidade", path: "/contabilidade/planos"},
                { name: "Vínculo" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>